export const environment = {
production: true,
  appUrl: "https://bavox.ch/",
  apiUrl: "https://staging.bavox.ch/api/v1",
  websocket: 'wss://staging.bavox.ch/',
  websocketpath: ''
};